<template>
  <div class="outer-wrapper">
    <section class="section">
            <img class="section-bg" :src="bgImg"/>
            <div class="row">
                <div class="section-title">
                    <h2>信息速递</h2>
                    <p></p>
                </div>
            </div>
            <div class="hrow">
                <div class="col-h">
                    <div class="list-content">
                        <div class="lc-title"><p>最新开工产品</p></div>
                        <div class="lc-content">
                            <ul>
                            <li></li>
              
                            
                            </ul>
                            <a>更多>></a>
                        </div>

                    </div>
                </div>
                
                <div class="col-h">
                    <div class="list-content list-right">
                        <div class="lc-title"><p>系统更新</p></div>
                        <div class="lc-content">
                            <ul>
                            <li>0.1Beta版系统正式上线</li>
                            
                            
                            </ul>
                            <a>更多>></a>
                        </div>

                    </div>
                </div>
            </div>
        </section>
  </div>
</template>
<script>
export default {
  name: "indexContent",

  data() {
    return {
      contentItems: [],
      contentSrc: {},
      advantageSrc: {
        a1: process.env.BASE_URL + "img/advantage1.png"
      }
    };
  },
  methods: {}
};
</script>
<style scoped>
.outer-wrapper {
        overflow: hidden;
        background-color: #f5f5f5;
        margin: 0 auto;
        position: relative;
        padding-bottom:20px;
    }

.section{
    position: relative;
    
}

.section-bg{
    position: absolute;
    width:100%;
    height:100%;
}
.row{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

}
.section-title {
    position: relative;
    margin-top: 75px;
    text-align: center;
}
.section-title h2 {
    font-size: 30px;
    letter-spacing: 0.05em;
    text-align: center;
    font-family: "Muli", sans-serif;
    font-weight: 600;
    color: #856363;
}

.section-title p {
    font-size: 18px;
    line-height: 30px;
    color: #848484;
}
.col-sm {
    -ms-flex: 0 0;
    flex: 0 0;
    padding: 10px;
}
.col-h{
    padding: 20px;
    overflow: hidden;
}
.col-t{
    -ms-flex: 0 0 33.333333%;
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
    padding: 20px;

}
.content-wrapper{
    background: #fff;
    height: 300px;
}
.list-content{
    background: #fff;
    height:200px;
    width:60%;
    position: relative;
}
.list-right{
    float: right;
}
.s-img{
    height:100%;
}
.num-wrapper{
    width:150px;
    padding: 20px;
}
.lc-title{
    background: #993333;
    height:40px;
    text-align: center;
}
.lc-title p{
    line-height: 40px;
    font-size: 14px;
    padding: 0 20px;
    color:#fff;
}
.lc-content{
    text-align: left;
    padding: 20px 40px;
    
}
.lc-content li{
    line-height: 20px;
    font-size:14px;
    color:#222;
    list-style-type:square;
}

.lc-content a{
    position: absolute;
    bottom:10px;
    right:10px;
}
.lc-content a:hover{
    color:#000;
}
.num-wrapper,.date-wrapper{
    text-align: center;
}
</style>